import { StringWithCopy } from "@components";
import Typography from "@components/typography/Typography";

type TopHeaderType = "domain" | "url" | "ip";

type Props = {
  type: TopHeaderType;
  value: string;
  Actions?: React.ComponentType;
  noMarginBottom?: boolean;
};

const TYPE_MAP = {
  ip: "IP",
  domain: "Domain",
  url: "URL"
} as const;

const TopHeader = ({ type, value, Actions, noMarginBottom }: Props) => (
  <header className="flex justify-space-between">
    <div
      className={`flex width-100-pc align-center flex-gap-2${
        noMarginBottom ? "" : " mb-10"
      }`}
    >
      <StringWithCopy value={value} className="width-100-pc" reverse>
        <Typography variant="body6" tag="span">
          [{TYPE_MAP[type]}] {value}
        </Typography>
      </StringWithCopy>
    </div>
    {Actions && <Actions />}
  </header>
);

export default TopHeader;
